import type { Rules } from "../../types";
import { limits, ultimateRequirement } from "./limits";
import { wealthLevels } from "./wealthLevels";
import { coreSkills } from "./coreSkills";
import { darkOfferings } from "./darkOfferings";
import { patrons } from "./patrons";
import { otherworldlyGifts } from "./otherworldlyGifts";
import { spellLists } from "./spells";
import { festiveGames } from "./festiveGames";
import { cabals } from "./cabals";

export const rulesV1: Rules = {
  metadata: {
    version: "1.0.0",
    label: "Game 1",
    releasedAt: "2026-03-01",
    description: "Ultimate Warlock LARP - Initial rules release",
  },
  limits,
  wealthLevels,
  ultimateRequirement,
  coreSkills,
  darkOfferings,
  patrons,
  otherworldlyGifts,
  spellLists,
  festiveGames,
  cabals,
};
